import React, { useEffect, useState } from "react";
import {
    ArrowLeftOutlined,
    UserOutlined,
    FileTextOutlined,
    FilePdfOutlined,
    SendOutlined,
    DollarOutlined,
    PlusCircleOutlined,
    WhatsAppOutlined,
    DownloadOutlined,
    PrinterOutlined,
    ShareAltOutlined,
    SyncOutlined,
    DownOutlined,
} from "@ant-design/icons";
import { Card, Select, DatePicker, Row, Col, Form, Button, Typography, Input, Space } from "antd";
import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import useMessage from "antd/es/message/useMessage";
import { QuotationService } from "../../../Services/Manage/QuotationService";
import dayjs from "dayjs";
import { InvoiceService } from "../../../Services/Manage/InvoiceService";
import AddInvoiceData from "./AddInvoiceData";
import { useLocation } from "react-router-dom";
import InvoiceProfessionalTemplate from "../template/InvoiceProfessionalTemplate";
import { ENDPOINT } from "../../../Services/ENDPOINT";
import { LetterService } from "../../../Services/Manage/LetterService";

const primaryColor = "rgba(11, 93, 148, 0.95)";

const InfoRow = ({ label, value, valueNode, last }) => (
    <div style={{ display: "flex", alignItems: "flex-start", marginBottom: last ? 0 : 12, fontSize: 13 }}>
        <span style={{ width: 110, color: "#6b7280", flexShrink: 0 }}>{label}</span>
        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
        {valueNode ? valueNode : <span style={{ fontWeight: 600, color: "#1f1f1f" }}>{value || "-"}</span>}
    </div>
);

const InfoItem = ({ label, value }) => (
    <div>
        <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>{label}</div>
        <div style={{ color: "#111827", fontSize: 14, fontWeight: 700, lineHeight: 1.5, minHeight: 24 }}>{value || "-"}</div>
    </div>
);

const ViewInvoice = () => {
    const location = useLocation();
    const id = location.state?.id;

    const [data, setData] = useState([]);
    const [message, msgConxt] = useMessage();
    const [eqData, setEqData] = useState([]);
    const [form] = Form.useForm();
    const [in_gen, setIn_gen] = useState("");
    const [Eqslected] = useState(true);
    const [baseData, setBasedata] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [invoiceScope, setInvoiceScope] = useState("");
    const [invoiceRecord, setInvoiceRecord] = useState(null);
    const [customerForm] = Form.useForm();
    const [isEnquiryBased, setIsEnquiryBased] = useState(false);
    const [paymentSummary, setPaymentSummary] = useState({ grandTotal: 0, totalReceived: 0 });

    // ---- Customer Information edit state ----
    const [editCustomer, setEditCustomer] = useState(false);
    const [customerInfoState, setCustomerInfoState] = useState({
        company_name: "",
        contact_person: "",
        mobile_no: "",
        email: "",
        gstin: "",
        address: "",
    });

    // ---- Invoice Details edit state ----
    const [editInvoiceDetails, setEditInvoiceDetails] = useState(false);
    const [invoiceDetailsState, setInvoiceDetailsState] = useState({
        invoice_date: "",
        due_date: "",
        reference: "",
        project: "",
        place_of_supply: "",
        status: "Draft",
        sales_executive: "",
    });

    const [orgDetails, setOrgDetails] = useState(null);

    const loadOrgDetails = async () => {
        try {
            const res = await LetterService.getAllFooter();
            setOrgDetails((res.data || [])[0] || null);
        } catch (e) { console.error(e); }
    };

    useEffect(() => {
        handleGetDataByQId(id);
        loadOrgDetails();
    }, [id]);

    useEffect(() => {
        setCustomerInfoState({
            company_name: invoiceRecord?.customer_name || invoiceRecord?.customer_company || eqData?.company_name || eqData?.name || "",
            contact_person: invoiceRecord?.customer_contact_person || eqData?.contact_person || eqData?.name || "",
            mobile_no: invoiceRecord?.customer_mobile || eqData?.mobile_no || eqData?.contact_whatsapp || "",
            email: invoiceRecord?.customer_email || eqData?.email || eqData?.contact_email || "",
            gstin: invoiceRecord?.customer_gstin || eqData?.gstin || "",
            address: invoiceRecord?.customer_address || eqData?.address || eqData?.location_city || "",
        });
    }, [eqData, invoiceRecord]);

    useEffect(() => {
        setInvoiceDetailsState({
            invoice_date: invoiceRecord?.invoice_date || "",
            due_date: invoiceRecord?.due_date || "",
            reference: invoiceRecord?.reference || eqData?.qu_no || eqData?.eq_id || "",
            project: invoiceRecord?.project || eqData?.project_name || eqData?.eq_description || "",
            place_of_supply: invoiceRecord?.place_of_supply || eqData?.place_of_supply || eqData?.location_city || "",
            status: invoiceRecord?.status || "Draft",
            sales_executive: invoiceRecord?.sales_executive || eqData?.assigned_to || eqData?.added_by || "",
        });
    }, [invoiceRecord, eqData]);

    const handleGetDatabyEqid = async (value) => {
        try {
            const request = await EnquiryService.getEnquiryDetailsById(value);
            if (request.status) setEqData(request.data);
        } catch (error) { console.error(error); }
    };

    const handleGetDataByQId = async (value) => {
        try {
            // STEP 1: fetch the invoice itself first — `value` is now the
            // invoice's OWN qu_no (== invoice_no for quotation-based invoices).
            const invoiceRes = await InvoiceService.getInvoiceByQuNo(value);
            const invRec = invoiceRes?.data ?? null;

            setInvoiceScope(invRec?.scope ?? "");
            setInvoiceRecord(invRec);
            if (invRec?.invoice_no) setIn_gen(invRec.invoice_no);

            // STEP 2: line items for THIS invoice always live under `value`
            // (its own qu_no), regardless of where it was generated from.
            const request = await QuotationService.getAllQuotationById(value);
            setRowData(request?.data?.quotation_data || []);
            setBasedata(request?.data?.quotation || {});

            const invSource = invRec?.source || null;
            const invEqId = invRec?.eq_id || null;
            const sourceQuNo = invRec?.source_qu_no || null;

            let enquiryData = null;
            if (invSource === "enquiry" && invEqId) {
                try {
                    const eqRes = await EnquiryService.getEnquiryDetailsById(invEqId);
                    if (eqRes.status && eqRes.data && eqRes.data.eq_id) enquiryData = eqRes.data;
                } catch (e) { /* ignore */ }
            }

            if (enquiryData) {
                setEqData(enquiryData);
                setIsEnquiryBased(true);
            } else if (invSource === "quotation" && sourceQuNo) {
                // Pull customer/quotation context from the ORIGINAL quotation
                // (sourceQuNo), not from `value` which is this invoice's own qu_no.
                setIsEnquiryBased(false);
                try {
                    const srcRequest = await QuotationService.getAllQuotationById(sourceQuNo);
                    const srcQuotation = srcRequest?.data?.quotation;
                    const isManual = srcQuotation && srcQuotation.eq_no === srcQuotation.qu_no;

                    if (isManual) {
                        const cust = srcRequest?.data?.customer || {};
                        setEqData({
                            name: cust.name,
                            company_name: cust.company_name,
                            mobile_no: cust.mobile_no,
                            address: cust.address,
                            eq_id: srcQuotation.eq_no,
                            qu_no: srcQuotation.qu_no,
                        });
                        customerForm.setFieldsValue({
                            name: cust.name,
                            mobile_no: cust.mobile_no,
                            address: cust.address,
                            note: cust.note,
                        });
                    } else {
                        const request_2 = await QuotationService.getEqCustomerByQId(sourceQuNo);
                        setEqData(request_2.data);
                    }
                } catch (e) {
                    console.error(e);
                }
            } else {
                // No quotation/enquiry source — manual invoice. Customer/quotation
                // row is keyed by `value` itself, same as before.
                setIsEnquiryBased(false);
                const quotation = request?.data?.quotation;
                const isManual = quotation && quotation.qu_no && quotation.eq_no === quotation.qu_no;
                if (isManual) {
                    const cust = request?.data?.customer || {};
                    setEqData({
                        name: cust.name,
                        company_name: cust.company_name,
                        mobile_no: cust.mobile_no,
                        address: cust.address,
                        eq_id: quotation.eq_no,
                        qu_no: quotation.qu_no,
                    });
                    customerForm.setFieldsValue({
                        name: cust.name,
                        mobile_no: cust.mobile_no,
                        address: cust.address,
                        note: cust.note,
                    });
                } else {
                    const request_2 = await QuotationService.getEqCustomerByQId(value);
                    setEqData(request_2?.data || {});
                }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const saveCustomerInfo = async () => {
        setEqData((prev) => ({
            ...prev,
            company_name: customerInfoState.company_name,
            name: customerInfoState.company_name,
            contact_person: customerInfoState.contact_person,
            mobile_no: customerInfoState.mobile_no,
            contact_whatsapp: customerInfoState.mobile_no,
            email: customerInfoState.email,
            contact_email: customerInfoState.email,
            gstin: customerInfoState.gstin,
            address: customerInfoState.address,
            location_city: customerInfoState.address,
        }));
        setEditCustomer(false);

        if (invoiceRecord?.id) {
            try {
                await InvoiceService.updateInvoice(
                    {
                        customer_name: customerInfoState.company_name || customerInfoState.contact_person,
                        customer_contact_person: customerInfoState.contact_person || null,
                        customer_mobile: customerInfoState.mobile_no,
                        customer_address: customerInfoState.address,
                        customer_gstin: customerInfoState.gstin,
                        customer_email: customerInfoState.email,
                    },
                    invoiceRecord.id
                );
                setInvoiceRecord((prev) => ({
                    ...prev,
                    customer_name: customerInfoState.company_name,
                    customer_contact_person: customerInfoState.contact_person,
                    customer_mobile: customerInfoState.mobile_no,
                    customer_address: customerInfoState.address,
                    customer_gstin: customerInfoState.gstin,
                    customer_email: customerInfoState.email,
                }));
            } catch (e) { console.error(e); }
        }
        if (baseData?.qu_no && !isEnquiryBased) {
            try {
                await InvoiceService.updateCustomer(
                    {
                        name: customerInfoState.company_name || customerInfoState.contact_person,
                        mobile_no: customerInfoState.mobile_no,
                        address: customerInfoState.address,
                    },
                    baseData.qu_no
                );
            } catch (e) { console.error(e); }
        }
    };

    const saveInvoiceDetails = async () => {
        const finalInvoiceDate = invoiceDetailsState.invoice_date || invoiceRecord?.invoice_date || null;

        setInvoiceRecord((prev) => ({
            ...prev,
            invoice_date: finalInvoiceDate,
            due_date: invoiceDetailsState.due_date,
            reference: invoiceDetailsState.reference,
            project: invoiceDetailsState.project,
            place_of_supply: invoiceDetailsState.place_of_supply,
            sales_executive: invoiceDetailsState.sales_executive,
        }));


        setEditInvoiceDetails(false);
        if (invoiceRecord?.id) {
            try {
                await InvoiceService.updateInvoice(
                    {
                        invoice_date: finalInvoiceDate,
                        due_date: invoiceDetailsState.due_date || null,
                        reference: invoiceDetailsState.reference || null,
                        project: invoiceDetailsState.project || null,
                        place_of_supply: invoiceDetailsState.place_of_supply || null,
                        sales_executive: invoiceDetailsState.sales_executive || null,
                    },
                    invoiceRecord.id
                );
            } catch (e) { console.error(e); }
        }
    };

    const getBase64Image = (url) =>
        new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                canvas.getContext("2d").drawImage(img, 0, 0);
                resolve(canvas.toDataURL("image/png"));
            };
            img.onerror = reject;
            img.src = url;
        });

    const numberToWords = (num) => {
        const a = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const g = ["", "Thousand", "Million", "Billion"];
        if (num === 0) return "Zero";
        let str = "", grp = 0;
        while (num > 0) {
            let chunk = num % 1000;
            if (chunk) {
                let s = "";
                if (chunk > 99) { s += a[Math.floor(chunk / 100)] + " Hundred "; chunk %= 100; }
                if (chunk > 19) { s += b[Math.floor(chunk / 10)] + " "; chunk %= 10; }
                if (chunk > 0) s += a[chunk] + " ";
                str = s + g[grp] + " " + str;
            }
            num = Math.floor(num / 1000); grp++;
        }
        return str.trim();
    };

    const handleDownloadInvoicePDF = async () => {
        try {
            const { BankService } = await import('../../../Services/Manage/BankService');
            let bankAcObj = null;
            if (invoiceRecord?.bank_id) {
                try {
                    const bankRes = await BankService.getAllBank();
                    bankAcObj = (bankRes?.data || []).find(b => Number(b.id) === Number(invoiceRecord.bank_id)) || null;
                } catch (e) { console.error(e); }
            }
            const letterHeadRes = await LetterService.getAllHead();
            const headerObj = (letterHeadRes.data || []).find(lh => lh.tag?.toLowerCase() === "header");
            const headerBase64 = headerObj ? await getBase64Image(`${ENDPOINT.base}/${headerObj.image_url}`) : "";
            let dgSignBase64 = "";
            let dgSignAspectRatio = null;
            try {
                if (invoiceRecord?.sign_id) {
                    const signRes = await QuotationService.getDigitalSign();
                    const signObj = (signRes?.data || []).find(s => Number(s.id) === Number(invoiceRecord.sign_id));
                    if (signObj) {
                        dgSignBase64 = await getBase64Image(`${ENDPOINT.base}/${signObj.image_path}`);
                    }
                }
            } catch (e) { console.error(e); }

            if (dgSignBase64) {
                dgSignAspectRatio = await new Promise((resolve) => {
                    const img = new Image();
                    img.onload = () => resolve(img.width / img.height);
                    img.onerror = () => resolve(null);
                    img.src = dgSignBase64;
                });
            }

            const footerObj = (letterHeadRes.data || []).find(lh => lh.tag?.toLowerCase() === "footer");
            const footerBase64 = footerObj ? await getBase64Image(`${ENDPOINT.base}/${footerObj.image_url}`) : "";

            let footerAspectRatio = null;
            if (footerBase64) {
                footerAspectRatio = await new Promise((resolve) => {
                    const img = new Image();
                    img.onload = () => resolve(img.width / img.height);
                    img.onerror = () => resolve(null);
                    img.src = footerBase64;
                });
            }

            const { ExpenseServices } = await import('../../../Services/Manage/ExpenseServices');
            const key = baseData?.qu_no || in_gen;
            const paymentRes = key ? await ExpenseServices.getPaymentByQuId(key) : { data: [] };
            const paymentHistory = paymentRes?.data || [];

            const computedGrandTotal = (rowData || []).reduce((sum, it) => {
                const qty = Number(it.qty) || 0, rate = Number(it.unitprice) || 0;
                const disc = Number(it.discount) || 0, tax = Number(it.tax) || 0;
                const taxable = qty * rate * (1 - disc / 100);
                return sum + taxable + taxable * (tax / 100);
            }, 0);

            const invoiceObj = {
                invoice_no: in_gen,
                invoice_date: invoiceDetailsState.invoice_date,
                due_date: invoiceDetailsState.due_date,
                reference: invoiceDetailsState.reference,
                project: invoiceDetailsState.project,
                status: invoiceDetailsState.status,
                grand_total: invoiceRecord?.grand_total || Math.round(computedGrandTotal),
                tc_content: invoiceRecord?.tc_content || null,
            };

            const enquiryObj = {
                company_name: customerInfoState.company_name,
                name: customerInfoState.contact_person,
                contact_person: customerInfoState.contact_person,
                mobile_no: customerInfoState.mobile_no,
                email: customerInfoState.email,
                gstin: customerInfoState.gstin,
                address: customerInfoState.address,
            };

            const pdfDoc = InvoiceProfessionalTemplate({
                invoice: invoiceObj,
                enquiry: enquiryObj,
                invoiceData: rowData || [],
                paymentHistory,
                headerBase64,
                footerBase64,
                footerAspectRatio,
                dgSignBase64,
                dgSignAspectRatio,
                numberToWords,
                bankAc: bankAcObj,
                orgDetails,
            });
            pdfDoc.save(`${in_gen || "Invoice"}.pdf`);
        } catch (e) {
            console.error(e);
        }
    };

    const buildInvoicePdfDoc = async () => {
        const { BankService } = await import('../../../Services/Manage/BankService');
        let bankAcObj = null;
        if (invoiceRecord?.bank_id) {
            try {
                const bankRes = await BankService.getAllBank();
                bankAcObj = (bankRes?.data || []).find(b => Number(b.id) === Number(invoiceRecord.bank_id)) || null;
            } catch (e) { console.error(e); }
        }
        const letterHeadRes = await LetterService.getAllHead();
        const headerObj = (letterHeadRes.data || []).find(lh => lh.tag?.toLowerCase() === "header");
        const headerBase64 = headerObj ? await getBase64Image(`${ENDPOINT.base}/${headerObj.image_url}`) : "";

        let dgSignBase64 = "";
        let dgSignAspectRatio = null;
        try {
            if (invoiceRecord?.sign_id) {
                const signRes = await QuotationService.getDigitalSign();
                const signObj = (signRes?.data || []).find(s => Number(s.id) === Number(invoiceRecord.sign_id));
                if (signObj) {
                    dgSignBase64 = await getBase64Image(`${ENDPOINT.base}/${signObj.image_path}`);
                }
            }
        } catch (e) { console.error(e); }

        if (dgSignBase64) {
            dgSignAspectRatio = await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img.width / img.height);
                img.onerror = () => resolve(null);
                img.src = dgSignBase64;
            });
        }

        const footerObj = (letterHeadRes.data || []).find(lh => lh.tag?.toLowerCase() === "footer");
        const footerBase64 = footerObj ? await getBase64Image(`${ENDPOINT.base}/${footerObj.image_url}`) : "";

        let footerAspectRatio = null;
        if (footerBase64) {
            footerAspectRatio = await new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(img.width / img.height);
                img.onerror = () => resolve(null);
                img.src = footerBase64;
            });
        }

        const { ExpenseServices } = await import('../../../Services/Manage/ExpenseServices');
        const key = baseData?.qu_no || in_gen;
        const paymentRes = key ? await ExpenseServices.getPaymentByQuId(key) : { data: [] };
        const paymentHistory = paymentRes?.data || [];

        const computedGrandTotal = (rowData || []).reduce((sum, it) => {
            const qty = Number(it.qty) || 0, rate = Number(it.unitprice) || 0;
            const disc = Number(it.discount) || 0, tax = Number(it.tax) || 0;
            const taxable = qty * rate * (1 - disc / 100);
            return sum + taxable + taxable * (tax / 100);
        }, 0);

        const invoiceObj = {
            invoice_no: in_gen,
            invoice_date: invoiceDetailsState.invoice_date,
            due_date: invoiceDetailsState.due_date,
            reference: invoiceDetailsState.reference,
            project: invoiceDetailsState.project,
            status: invoiceDetailsState.status,
            grand_total: invoiceRecord?.grand_total || Math.round(computedGrandTotal),
            tc_content: invoiceRecord?.tc_content || null,
        };

        const enquiryObj = {
            company_name: customerInfoState.company_name,
            name: customerInfoState.contact_person,
            contact_person: customerInfoState.contact_person,
            mobile_no: customerInfoState.mobile_no,
            email: customerInfoState.email,
            gstin: customerInfoState.gstin,
            address: customerInfoState.address,
        };

        return InvoiceProfessionalTemplate({
            invoice: invoiceObj,
            enquiry: enquiryObj,
            invoiceData: rowData || [],
            paymentHistory,
            headerBase64,
            footerBase64,
            footerAspectRatio,
            dgSignBase64,
            dgSignAspectRatio,
            numberToWords,
            bankAc: bankAcObj,
            orgDetails,
        });
    };



    const handlePrintInvoicePDF = async () => {
        try {
            const pdfDoc = await buildInvoicePdfDoc();
            const blobUrl = pdfDoc.output("bloburl");
            const printWindow = window.open(blobUrl, "_blank");
            if (printWindow) {
                printWindow.addEventListener("load", () => {
                    printWindow.focus();
                    printWindow.print();
                });
            } else {
                message.warning("Please allow pop-ups to print the invoice.");
            }
        } catch (e) {
            console.error(e);
            message.error("Failed to open invoice for printing");
        }
    };

   const handleSendInvoice = async () => {
        if (!invoiceRecord?.id) return;
        try {
            const pdfDoc = await buildInvoicePdfDoc();
            pdfDoc.save(`${in_gen || "Invoice"}.pdf`);

            await InvoiceService.updateInvoice({ status: "Sent", sent_on: dayjs().toISOString() }, invoiceRecord.id);
            setInvoiceRecord((p) => ({ ...p, status: "Sent", sent_on: dayjs().toISOString() }));
            setInvoiceDetailsState((p) => ({ ...p, status: "Sent" }));

            const to = encodeURIComponent(customerInfoState.email || "");
            const subject = encodeURIComponent(`Invoice ${in_gen}`);
            const body = encodeURIComponent(
                `Hello ${customerInfoState.contact_person || customerInfoState.company_name || ""},\n\nPlease find attached invoice ${in_gen}.\n\nThank you for your business.`
            );
            window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${subject}&body=${body}`, "_blank");

            message.success("Invoice marked as Sent. PDF downloaded — attach it in Gmail.");
        } catch (e) {
            console.error(e);
            message.error("Failed to send invoice.");
        }
    };

    const handleSendWhatsApp = () => {
        const rawMobile = customerInfoState.mobile_no || "";
        const digits = rawMobile.replace(/[^\d]/g, "");
        if (!digits) {
            message.warning("No customer mobile number available.");
            return;
        }
        const phone = digits.length === 10 ? `91${digits}` : digits;
        const text = encodeURIComponent(
            `Hello ${customerInfoState.contact_person || customerInfoState.company_name || ""}, please find your invoice ${in_gen || ""} for ₹${Number(paymentSummary.grandTotal || 0).toLocaleString("en-IN")}. Thank you for your business.`
        );
        window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
    };

    const statusColors = {
        Draft: { bg: "#fef3c7", color: "#b45309" },
        Created: { bg: "#e0edff", color: "#2563eb" },
        Sent: { bg: "#e0edff", color: "#2563eb" },
        "Paid Partially": { bg: "#dcfce7", color: "#16a34a" },
        Paid: { bg: "#dcfce7", color: "#16a34a" },
        Overdue: { bg: "#fee2e2", color: "#dc2626" },
    };

    const computeStatus = () => {
        if (!invoiceRecord?.id) return "Draft";

        const baseStatus = invoiceRecord?.status || "Draft";
        const invoiceVal = Number(paymentSummary.grandTotal || 0);
        const received = Number(paymentSummary.totalReceived || 0);
        const dueDate = invoiceDetailsState.due_date;
        const dueDatePassed = dueDate && new Date(dueDate) < new Date();

        if (invoiceVal > 0 && received >= invoiceVal) return "Paid";

        if (received > 0 && received < invoiceVal) {
            return dueDatePassed ? "Overdue" : "Paid Partially";
        }

        if (dueDatePassed && received <= 0) return "Overdue";

        return baseStatus;
    };
    const currentStatus = computeStatus();
    const statusStyle = statusColors[currentStatus] || statusColors.Draft;

    return (
        <>
            {msgConxt}

            <Card style={{ borderRadius: 12, marginBottom: 12 }} bodyStyle={{ padding: 16 }}>
                {/* Header */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 18, flexWrap: "wrap" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <ArrowLeftOutlined style={{ cursor: "pointer", fontSize: 18, color: "#111827" }} onClick={() => window.history.back()} />
                        <Typography.Text style={{ color: primaryColor, fontWeight: 700, fontSize: 16 }}>Invoices</Typography.Text>
                        <Typography.Text style={{ color: "#9ca3af" }}>/</Typography.Text>
                        <Typography.Text style={{ color: primaryColor, fontWeight: 800, fontSize: 16 }}>{in_gen || "View Invoice"}</Typography.Text>
                        <span style={{ background: statusStyle.bg, color: statusStyle.color, padding: "4px 12px", borderRadius: 6, fontWeight: 700, fontSize: 12 }}>
                            {currentStatus}
                        </span>
                    </div>

                    <Space wrap>
                        <Button icon={<FilePdfOutlined />} onClick={handleDownloadInvoicePDF}>Preview PDF</Button>
                        <Button
                            type="primary"
                            icon={<SendOutlined />}
                            style={{ background: "#16a34a", borderColor: "#16a34a" }}
                            onClick={handleSendInvoice}
                        >
                            Send Invoice
                        </Button>
                        <Button icon={<DollarOutlined />} style={{ background: "#7c5cff", borderColor: "#7c5cff", color: "#fff" }}>Record Payment</Button>
                        <Button icon={<PlusCircleOutlined />} style={{ color: "#b45309", borderColor: "#fcd34d" }}>Create Credit Note</Button>
                        <Button>More Actions <DownOutlined /></Button>
                    </Space>
                </div>

                {/* Invoice Information box */}
                <div style={{ border: "1px solid #eef0f5", borderRadius: 10, padding: "5px 18px 18px", background: "#fff", marginBottom: 16 }}>
                    <Typography.Title level={5} style={{ margin: "0 0 18px", fontWeight: 600, fontSize: 16, color: primaryColor, display: "flex", alignItems: "center", gap: 8 }}>
                        <FileTextOutlined />
                        Invoice Information
                    </Typography.Title>

                    <Row gutter={[24, 18]}>
                        <Col xs={24} sm={12} md={4}><InfoItem label="Invoice No" value={in_gen || "-"} /></Col>
                        <Col xs={24} sm={12} md={4}>
                            <InfoItem label="Invoice Date" value={invoiceDetailsState.invoice_date ? dayjs(invoiceDetailsState.invoice_date).format("DD MMM YYYY") : "-"} />
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <InfoItem label="Due Date" value={invoiceDetailsState.due_date ? dayjs(invoiceDetailsState.due_date).format("DD MMM YYYY") : "-"} />
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <InfoItem
                                label="Status"
                                value={
                                    <span style={{ background: statusStyle.bg, color: statusStyle.color, padding: "6px 12px", borderRadius: 6, fontWeight: 700 }}>
                                        {currentStatus}
                                    </span>
                                }
                            />
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <InfoItem label="Reference" value={baseData?.qu_no && baseData.qu_no !== in_gen ? baseData.qu_no : (eqData?.eq_id || "-")} />
                        </Col>
                        <Col xs={24} sm={12} md={4}>
                            <InfoItem
                                label="Source"
                                value={(() => {
                                    const isManualEntry = baseData?.qu_no && baseData?.eq_no === baseData?.qu_no;
                                    if (isEnquiryBased) {
                                        return `Enquiry - ${eqData?.eq_id || baseData?.eq_no || "-"}`;
                                    }
                                    if (isManualEntry) {
                                        return `Direct Invoice - ${customerInfoState.company_name || customerInfoState.contact_person || "-"}`;
                                    }
                                    return `Quotation - ${baseData?.qu_no || "-"}`;
                                })()}
                            />
                        </Col>
                    </Row>
                </div>

                {/* 4 cards */}
                <Row gutter={[16, 16]}>
                    {/* Customer Information */}
                    <Col xs={24} md={6}>
                        <Card style={{ borderRadius: 12, height: "100%" }} bodyStyle={{ padding: 16 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                                <Typography.Text strong style={{ color: primaryColor, fontSize: 15 }}>
                                    <UserOutlined style={{ marginRight: 8 }} />
                                    Customer Information
                                </Typography.Text>
                                {editCustomer ? (
                                    <span>
                                        <Button type="link" size="small" onClick={saveCustomerInfo} style={{ padding: "0 4px" }}>Save</Button>
                                        <Button type="link" size="small" onClick={() => setEditCustomer(false)} style={{ padding: "0 4px" }}>Cancel</Button>
                                    </span>
                                ) : (
                                    <Button type="link" size="small" style={{ padding: 0, color: primaryColor, fontWeight: 500 }} onClick={() => setEditCustomer(true)}>
                                        Edit
                                    </Button>
                                )}
                            </div>

                            {editCustomer ? (
                                <>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Company Name</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={customerInfoState.company_name}
                                            onChange={(e) => setCustomerInfoState((p) => ({ ...p, company_name: e.target.value }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Contact Person</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={customerInfoState.contact_person}
                                            onChange={(e) => setCustomerInfoState((p) => ({ ...p, contact_person: e.target.value }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Mobile No</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={customerInfoState.mobile_no}
                                            onChange={(e) => setCustomerInfoState((p) => ({ ...p, mobile_no: e.target.value }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Email</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={customerInfoState.email}
                                            onChange={(e) => setCustomerInfoState((p) => ({ ...p, email: e.target.value }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>GSTIN</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={customerInfoState.gstin}
                                            onChange={(e) => setCustomerInfoState((p) => ({ ...p, gstin: e.target.value }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Address</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input.TextArea rows={2} size="small" value={customerInfoState.address}
                                            onChange={(e) => setCustomerInfoState((p) => ({ ...p, address: e.target.value }))} />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div style={{ fontSize: 15, fontWeight: 700, color: "#1f1f1f", marginBottom: 12 }}>
                                        {customerInfoState.company_name || "-"}
                                    </div>
                                    <InfoRow label="Contact Person" value={customerInfoState.contact_person} />
                                    <InfoRow label="Mobile No" value={customerInfoState.mobile_no} />
                                    <InfoRow label="Email" value={customerInfoState.email} />
                                    <InfoRow label="GSTIN" value={customerInfoState.gstin} />
                                    <InfoRow label="Address" value={customerInfoState.address} last />
                                </>
                            )}
                        </Card>
                    </Col>

                    {/* Invoice Details */}
                    <Col xs={24} md={6}>
                        <Card style={{ borderRadius: 12, height: "100%" }} bodyStyle={{ padding: 16 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
                                <Typography.Text strong style={{ color: primaryColor, fontSize: 15 }}>
                                    <FileTextOutlined style={{ marginRight: 8 }} />
                                    Invoice Details
                                </Typography.Text>
                                {editInvoiceDetails ? (
                                    <span>
                                        <Button type="link" size="small" onClick={saveInvoiceDetails} style={{ padding: "0 4px" }}>Save</Button>
                                        <Button type="link" size="small" onClick={() => setEditInvoiceDetails(false)} style={{ padding: "0 4px" }}>Cancel</Button>
                                    </span>
                                ) : (
                                    <Button type="link" size="small" style={{ padding: 0, color: primaryColor, fontWeight: 500 }} onClick={() => setEditInvoiceDetails(true)}>
                                        Edit
                                    </Button>
                                )}
                            </div>

                            {editInvoiceDetails ? (
                                <>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Invoice Number</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={in_gen} disabled />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Invoice Date</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <DatePicker size="small" style={{ width: "100%" }} format="DD MMM YYYY"
                                            value={invoiceDetailsState.invoice_date ? dayjs(invoiceDetailsState.invoice_date) : null}
                                            onChange={(v) => setInvoiceDetailsState((p) => ({ ...p, invoice_date: v ? dayjs(v).format("YYYY-MM-DD") : "" }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Due Date</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <DatePicker size="small" style={{ width: "100%" }} format="DD MMM YYYY"
                                            value={invoiceDetailsState.due_date ? dayjs(invoiceDetailsState.due_date) : null}
                                            onChange={(v) => setInvoiceDetailsState((p) => ({ ...p, due_date: v ? dayjs(v).format("YYYY-MM-DD") : "" }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Reference</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={invoiceDetailsState.reference}
                                            onChange={(e) => setInvoiceDetailsState((p) => ({ ...p, reference: e.target.value }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Project</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={invoiceDetailsState.project}
                                            onChange={(e) => setInvoiceDetailsState((p) => ({ ...p, project: e.target.value }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Place of Supply</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={invoiceDetailsState.place_of_supply}
                                            onChange={(e) => setInvoiceDetailsState((p) => ({ ...p, place_of_supply: e.target.value }))} />
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Status</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <span style={{ background: statusStyle.bg, color: statusStyle.color, padding: "3px 10px", borderRadius: 6, fontWeight: 600, fontSize: 11 }}>
                                            {currentStatus}
                                        </span>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                                        <span style={{ width: 110, color: "#6b7280", flexShrink: 0, fontSize: 13 }}>Sales Executive</span>
                                        <span style={{ color: "#6b7280", marginRight: 6 }}>:</span>
                                        <Input size="small" value={invoiceDetailsState.sales_executive}
                                            onChange={(e) => setInvoiceDetailsState((p) => ({ ...p, sales_executive: e.target.value }))} />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <InfoRow label="Invoice Number" value={in_gen} />
                                    <InfoRow label="Invoice Date" value={invoiceDetailsState.invoice_date ? dayjs(invoiceDetailsState.invoice_date).format("DD MMM YYYY") : "-"} />
                                    <InfoRow label="Due Date" value={invoiceDetailsState.due_date ? dayjs(invoiceDetailsState.due_date).format("DD MMM YYYY") : "-"} />
                                    <InfoRow label="Reference" value={invoiceDetailsState.reference} />
                                    <InfoRow label="Project" value={invoiceDetailsState.project} />
                                    <InfoRow label="Place of Supply" value={invoiceDetailsState.place_of_supply} />
                                    <InfoRow
                                        label="Status"
                                        valueNode={
                                            <span style={{ background: statusStyle.bg, color: statusStyle.color, padding: "2px 12px", borderRadius: 6, fontWeight: 600, fontSize: 11 }}>
                                                {currentStatus}
                                            </span>
                                        }
                                    />
                                    <InfoRow label="Sales Executive" value={invoiceDetailsState.sales_executive} last />
                                </>
                            )}
                        </Card>
                    </Col>

                    {/* Payment Summary */}
                    <Col xs={24} md={6}>
                        <Card style={{ borderRadius: 12, height: "100%" }} bodyStyle={{ padding: 16 }}>
                            <Typography.Text strong style={{ color: primaryColor, fontSize: 15, display: "block", marginBottom: 14 }}>
                                Payment Summary
                            </Typography.Text>
                            {(() => {
                                const invoiceVal = Number(paymentSummary.grandTotal || 0);
                                const received = Number(paymentSummary.totalReceived || 0);
                                const pending = Math.max(0, invoiceVal - received);
                                const isOverdue = currentStatus === "Overdue";
                                const overdue = isOverdue ? pending : 0;
                                const progress = invoiceVal > 0 ? Math.min(100, Math.round((received / invoiceVal) * 100)) : 0;
                                const fmt = (v) => `₹ ${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
                                return (
                                    <>
                                        <InfoRow label="Invoice Value" value={fmt(invoiceVal)} />
                                        <InfoRow label="Received Amount" valueNode={<span style={{ fontWeight: 600, color: "#16a34a" }}>{fmt(received)}</span>} />
                                        <InfoRow label="Pending Amount" valueNode={<span style={{ fontWeight: 600, color: "#dc2626" }}>{fmt(pending)}</span>} />
                                        <InfoRow label="Overdue Amount" valueNode={<span style={{ fontWeight: 600, color: overdue > 0 ? "#dc2626" : "#1f1f1f" }}>{fmt(overdue)}</span>} last />
                                        <div style={{ marginTop: 14 }}>
                                            <Typography.Text style={{ fontSize: 13, color: "#6b7280", display: "block", marginBottom: 6 }}>
                                                Payment Progress
                                            </Typography.Text>
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <div style={{ flex: 1, height: 6, borderRadius: 4, background: "#f0f0f0", overflow: "hidden" }}>
                                                    <div style={{ width: `${progress}%`, height: "100%", background: "#16a34a" }} />
                                                </div>
                                                <Typography.Text style={{ fontSize: 12, fontWeight: 600 }}>{progress}%</Typography.Text>
                                            </div>
                                        </div>
                                    </>
                                );
                            })()}
                        </Card>
                    </Col>

                    {/* Quick Actions */}
                    <Col xs={24} md={6}>
                        <Card style={{ borderRadius: 12, height: "100%" }} bodyStyle={{ padding: 16 }}>
                            <Typography.Text strong style={{ color: primaryColor, fontSize: 15, display: "block", marginBottom: 14 }}>
                                Quick Actions
                            </Typography.Text>
                            <Space direction="vertical" style={{ width: "100%" }} size={8}>
                                <Button block icon={<WhatsAppOutlined />} style={{ textAlign: "left" }} onClick={handleSendWhatsApp}>Send WhatsApp</Button>
                                <Button block icon={<DownloadOutlined />} style={{ textAlign: "left" }} onClick={handleDownloadInvoicePDF}>Download PDF</Button>
                                <Button block icon={<PrinterOutlined />} style={{ textAlign: "left" }} onClick={handlePrintInvoicePDF}>Print Invoice</Button>
                                <Button block icon={<ShareAltOutlined />} style={{ textAlign: "left" }}>Share Payment Link</Button>
                                <Button block icon={<SyncOutlined />} style={{ textAlign: "left" }}>Create Recurring Invoice</Button>
                            </Space>
                        </Card>
                    </Col>
                </Row>

                {/* Items table */}
                <div style={{ marginTop: 16 }}>
                    <AddInvoiceData
                        key={eqData?.eq_id || baseData?.qu_no || in_gen}
                        Eqslected={Eqslected}
                        invoice_no={in_gen}
                        data={baseData}
                        eqData={eqData}
                        rowData={rowData}
                        baseData={baseData}
                        customerForm={customerForm}
                        invoiceScope={invoiceScope}
                        invoiceId={invoiceRecord?.id ?? null}
                        invoiceDate={invoiceRecord?.invoice_date ?? null}
                        invoiceQuNo={invoiceRecord?.qu_no ?? null}
                        invoiceRecord={invoiceRecord}
                        extraDetails={invoiceDetailsState}
                        viewMode={true}
                  onPaymentSummaryChange={setPaymentSummary}
                        onInvoiceGenerated={setInvoiceRecord}
                        onSendInvoice={handleSendInvoice}
                    />
                </div>
            </Card>
        </>
    );
};

export default ViewInvoice;